import { path } from './helpers'

const ROOTS_USER = '/user'
const ROOTS_AUTH = '/authentication'

const ROOTS_PROMOTER = '/promoter/hub/v1'

export const API_USER = {
  auth: {
    tokenClaim: path(ROOTS_AUTH, '/guest/v1/token/claim'),
    oneTimeToken: path(ROOTS_AUTH, '/v1/token'),
    signInByPhone: path(ROOTS_AUTH, '/guest/v1/phone/sign-in'),
    signInByEmail: path(ROOTS_AUTH, '/guest/v1/sign-in'),
    signInBySSO: path(ROOTS_AUTH, '/guest/v1/login-sso-hub'),
    getSSOToken: path(ROOTS_AUTH, '/guest/v1/get-sso'),
    requestOtpByPhone: path(ROOTS_AUTH, '/guest/v1/phone/otp/send'),
    verifyOtp: path(ROOTS_AUTH, '/guest/v1/phone/otp/verify'),
    requestHubOtp: path(ROOTS_USER, '/hub/v1/otp/send'),
    refreshToken: path(ROOTS_AUTH, '/guest/v1/refresh-token'),
    signOut: path(ROOTS_AUTH, '/v1/logout'),
  },
  profile: {
    root: path(ROOTS_USER, '/v3/profile'),
  },
  role: {
    root: path(ROOTS_USER, '/hub/v1/role'),
  },
  organizations: path(ROOTS_USER, '/hub/v1/organizations'),
  promoter: {
    performance_list: path(
      ROOTS_PROMOTER,
      '/conversion/performance/list',
    ),
  },
}

export const API_FINANCIAL = {
  approvals: {
    // GET with ?token= to fetch the request; POST { token, action } to decide.
    action: path(ROOTS_USER, '/hub/v1/financial/approvals/action'),
  },
  // Both routes respond immediately for an Owner (COMPLETED/EXECUTED) but go
  // to Owner approval for anyone else (PENDING) — see services/financial.
  withdraw: path(ROOTS_USER, '/hub/v1/financial/withdraw'),
  bankAccount: path(ROOTS_USER, '/hub/v1/financial/bank-account'),
}

export const API_TEAM = {
  members: {
    list: path(ROOTS_USER, '/hub/v1/members'),
    detail: (memberMaskId: string) =>
      path(ROOTS_USER, `/hub/v1/members/${memberMaskId}`),
    invite: path(ROOTS_USER, '/hub/v1/members/invite'),
    resendInvite: (memberMaskId: string) =>
      path(ROOTS_USER, `/hub/v1/members/${memberMaskId}/resend-invite`),
  },
  permissions: {
    matrix: path(ROOTS_USER, '/hub/v1/permissions/matrix'),
  },
  roles: path(ROOTS_USER, '/hub/v1/roles'),
  me: path(ROOTS_USER, '/hub/v1/me'),
}
